module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1000.b91a2054.svg";